<template>
  <div>
    <div class="contents">
      <h4 class="subtitle">{{ $t("title.admin.scoreboard_hole") }}</h4>
      <table class="table board table-sm">
        <thead>
          <tr>
            <th class="col-auto">{{ $t("title.common.nickname") }}</th>
            <th class="col-auto">{{ $t("title.common.hole") }}</th>
            <th class="col-auto">{{ $t("title.common.par") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.shot") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.score") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.completed") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="playerlist.length > 0">
          <template v-for="(val, idx) in playerlist">
            <template v-for="(hole, idx2) in val.holelist">
              <tr
                :key="idx + '_' + idx2 + 'h'"
                :class="{ 'bg-red': hole.delete_flag === '1' }"
              >
                <td class="col-auto text-start">
                  <MemberInfo
                    :nickname="val.gameplayerinfo.nickname"
                    :playerno="val.gameplayerinfo.playerno"
                    :no_img="true"
                  />
                </td>
                <td class="col-auto">{{ hole.hole }}H</td>
                <td class="col-auto">
                  {{ hole.par }}
                </td>
                <td class="col-auto d-none d-lg-table-cell">
                  {{ hole.shot }}
                </td>
                <td class="col-auto d-none d-lg-table-cell">
                  {{ hole.score }}
                </td>
                <td class="col-auto d-none d-lg-table-cell text-date">
                  {{ hole.timezone_date | dateformat }}
                </td>
                <td class="col-auto d-none d-lg-table-cell">
                  <label
                    :class="[
                      hole.flag == '1'
                        ? 'status-done px-2'
                        : 'status-drop px-2',
                    ]"
                  >
                    {{ hole.flag == "1" ? "O" : "X" }}
                  </label>
                </td>
                <td class="td-arrow" @click="toggle_tr(idx + '_' + idx2)">
                  <img
                    src="/img/arrow_none_collapsed.png"
                    :class="{
                      'btn-toggle-arrow': view_hide === idx + '_' + idx2,
                    }"
                  />
                </td>
              </tr>
              <tr
                class="col-auto d-lg-none"
                :class="{ show: view_hide === idx + '_' + idx2 }"
                :key="idx + '_' + idx2 + 'r'"
                v-if="view_hide === idx + '_' + idx2"
              >
                <td colspan="8">
                  <div class="toggle-content">
                    <div class="row">
                      <div class="col-5">{{ $t("title.admin.shot") }}</div>
                      <div class="col-7">{{ hole.shot }}</div>
                    </div>
                    <div class="row">
                      <div class="col-5">
                        {{ $t("title.common.score") }}
                      </div>
                      <div class="col-7">{{ hole.score }}</div>
                    </div>
                    <div class="row">
                      <div class="col-5">{{ $t("title.common.date") }}</div>
                      <div class="col-7 text-date">
                        {{ hole.timezone_date | dateformat }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5">
                        {{ $t("title.admin.completed") }}
                      </div>
                      <div class="col-7">
                        <label
                          :class="[
                            hole.flag == '1'
                              ? 'status-done px-2'
                              : 'status-drop px-2',
                          ]"
                        >
                          {{ hole.flag == "1" ? "O" : "X" }}
                        </label>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <h4 class="subtitle mt-5">{{ $t("title.admin.scoreboard_game") }}</h4>
      <table class="table board table-sm">
        <thead>
          <tr>
            <th class="col-auto">{{ $t("title.common.nickname") }}</th>
            <th class="col-auto">{{ $t("title.common.location") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.hole") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.par") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.shot") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.score") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.mulligan") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>

        <tbody v-if="playerlist.length > 0">
          <template v-for="(val, idx3) in playerlist">
            <tr
              :key="idx3 + 't'"
              :class="{ 'bg-red': val.gameplayerinfo.delete_flag === '1' }"
            >
              <td class="col-auto text-start">
                <MemberInfo
                  :nickname="val.total.nickname"
                  :playerno="val.total.playerno"
                  :no_img="true"
                />
              </td>
              <td class="col-auto shop-name">{{ val.total.shopname }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ val.total.totalhole }}H
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ val.total.totalpar }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ val.total.totalshot }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ val.total.totalscore }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ val.total.totalmulligan }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                {{ val.total.timezone_date | dateformat }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <b-form-checkbox
                  :checked="
                    val.gameplayerinfo.delete_flag === '1' ? false : true
                  "
                  size="lg"
                  switch
                  @click.native.prevent.capture="
                    delete_flag_chg(val.gameplayerinfo.gameplayerno, $event)
                  "
                >
                </b-form-checkbox>
              </td>
              <td class="td-arrow" @click="toggle_tr2(idx3)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide2 === idx3 }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none"
              :class="{ show: view_hide2 === idx3 }"
              :key="idx3 + 'r'"
              v-if="view_hide2 === idx3"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.hole") }}</div>
                    <div class="col-7">{{ val.total.totalhole }}H</div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.par") }}</div>
                    <div class="col-7">{{ val.total.totalpar }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.admin.shot") }}</div>
                    <div class="col-7">{{ val.total.totalshot }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.score") }}</div>
                    <div class="col-7">{{ val.total.totalscore }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.admin.mulligan") }}
                    </div>
                    <div class="col-7">{{ val.total.totalmulligan }}</div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-7 text-date">
                      {{ val.total.timezone_date | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.control") }}</div>
                    <div class="col-7">
                      <b-form-checkbox
                        :checked="
                          val.gameplayerinfo.delete_flag === '1' ? false : true
                        "
                        size="lg"
                        style="padding-left: 2.5em; padding-top: 0px"
                        switch
                        @click.native.prevent.capture="
                          delete_flag_chg(
                            val.gameplayerinfo.gameplayerno,
                            $event
                          )
                        "
                      >
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'GameDataView',
              query: {
                /*gameno: gameno,
                startdate: startdate,
                starttime: starttime,
                enddate: enddate,
                endtime: endtime,*/
              },
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/gamedata";

export default {
  name: "GameDataScoreBoard",
  data() {
    return {
      gameno: this.$route.query.gameno,
      startdate: this.$route.query.startdate,
      starttime: this.$route.query.starttime,
      enddate: this.$route.query.enddate,
      endtime: this.$route.query.endtime,
      playerlist: [],
      holelist: [],
      totallist: [],
      playerintolist: [],
      view_hide: null,
      view_hide2: null,

      form: {
        delete_flag: false,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      ax.gameDataScore(this.gameno, (data) => {
        // console.log(data);
        if (data) {
          this.playerlist = data.playerlist;
          // for (let i = 0; i < this.playerlist.length; i++) {
          //   this.holelist.push(this.playerlist[i].holelist);
          //   this.totallist.push(this.playerlist[i].total);
          //   this.playerintolist.push(this.playerlist[i].gameplayerinfo);
          // }
        } else {
          // this.holelist = [];
          // this.totallist = [];
          // this.playerintolist = [];
        }
      });
    },

    delete_flag_chg(player2_fk, e) {
      console.log("this.form.delete_flag", e.target.checked);
      console.log("player2_fk", player2_fk);
      if (e.target.checked === true) {
        alert("The restoration function is being prepared.");

        e.stopPropagation();
        e.preventDefault();
        return false;
      }
      if (confirm(this.$i18n.t("text.common.confirm"))) {
        ax.set_delete_flag(
          this.gameno,
          player2_fk,
          e.target.checked,
          (flag, data) => {
            // alert(data.message);

            if (flag) {
              if (data.code === 200) {
                this.getList();
              }
              // this.$bvModal.hide("modal-correction");
            } else {
              return false;
            }
          }
        );
      } else {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    toggle_tr2(index) {
      if (this.view_hide2 === index) this.view_hide2 = null;
      else this.view_hide2 = index;
    },
  },
};
</script>
<style scoped>
.bg-red {
  background-color: #ffcccc;
}
</style>
